export default class {
    onCreate() {
        this.state = {
            legalOpen: false
        };
    }
    toggleLegal() {
        this.state.legalOpen = !this.state.legalOpen;
    }
}
